import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import store from '@store/index'
import {_CONST} from "@/constants/constants";

Vue.use(VueNativeSock, Vue.prototype.$env.wsUri, {
  store,
  format: 'json',
  reconnection: true,
  reconnectionAttempts: _CONST.wsReconnextMaxCount,
  reconnectionDelay: 3000,
  connectManually: true,
});
